export default __webpack_public_path__ + "static/media/invite-plus.729774aa.svg";